import React, { useState } from "react";



import {

  Box,

  Paper,

  Typography,

  TextField,

  Button,

  MenuItem,

  Alert,

  IconButton,

} from "@mui/material";



import {

  BusinessOutlined,

  SaveOutlined,

  CloudUploadOutlined,

  LocationOnOutlined,

  ReceiptLongOutlined,

  AccountBalanceOutlined,

  PhoneOutlined,

  EmailOutlined,

  LanguageOutlined,

  Clear,

} from "@mui/icons-material";



import logo from "../../../../assets/images/praneesh-infotech-logo.png";



const CompanySetup = () => {
const [logoPreview, setLogoPreview] = useState(logo);



  const [formData, setFormData] = useState({

    companyName: "Praneesh Infotech",

    legalName: "Praneesh Infotech",

    companyType: "Proprietorship",



    email: "praneeshinfotech@gmail.com",

    phone: "",

    mobile: "",

    website: "https://praneeshinfotech.com/",



    address1: "",

    address2: "",

    city: "Erode",

    state: "Tamil Nadu",

    pincode: "",

    country: "India",



    gstin: "",

    pan: "",

    cin: "",

    tan: "",

    msme: "",



    bankName: "",

    accountHolder: "",

    accountNumber: "",

    ifsc: "",

    branch: "",



    invoicePrefix: "INV",

    quotationPrefix: "QUO",

    purchasePrefix: "PUR",

    receiptPrefix: "REC",



    invoiceTerms:

      "Payment should be made within the agreed payment terms.",



    invoiceNotes:

      "Thank you for your business.",

  });
  const handleChange = (event) => {

    const { name, value } = event.target;



    setFormData((previous) => ({

      ...previous,

      [name]: value,

    }));

  };



  const handleLogoUpload = (event) => {

    const file = event.target.files?.[0];



    if (!file) return;



    const allowedTypes = [

      "image/png",

      "image/jpeg",

      "image/webp",

    ];



    if (!allowedTypes.includes(file.type)) {

      alert("Please upload PNG, JPG or WEBP image.");

      return;

    }



    if (file.size > 2 * 1024 * 1024) {

      alert("Logo size should be less than 2 MB.");

      return;

    }



    setLogoPreview(URL.createObjectURL(file));

  };



  const handleRemoveLogo = () => {

    setLogoPreview(null);

  };



  const handleSubmit = (event) => {

    event.preventDefault();



    console.log("Company Setup:", formData);



    alert("Company details saved successfully.");

  };



  const handleReset = () => {

    window.location.reload();

  };
  return (

    <Box

      sx={{

        minHeight: "100%",

        backgroundColor: "#F5F7F9",

        pb: 10,

      }}

    >

      {/* ======================================================

          PAGE HEADER

      ====================================================== */}



      <Box

        sx={{

          backgroundColor: "#FFFFFF",

          borderBottom: "1px solid #E4E7EC",

          px: {

            xs: 2,

            md: 3,

          },

          py: 2.5,

          mb: 2,

        }}

      >

        <Box

          sx={{

            display: "flex",

            justifyContent: "space-between",

            alignItems: {

              xs: "flex-start",

              md: "center",

            },

            flexDirection: {

              xs: "column",

              md: "row",

            },

            gap: 2,

          }}

        >

          <Box>

            <Typography

              sx={{

                fontSize: {

                  xs: 21,

                  md: 24,

                },

                fontWeight: 700,

                color: "#1D2939",

              }}

            >

              Company Setup

            </Typography>



            <Typography

              sx={{

                mt: 0.5,

                fontSize: 13.5,

                color: "#667085",

              }}

            >

              Manage your company profile, tax,

              banking and document settings.

            </Typography>

          </Box>

        </Box>

      </Box>
      {/* ======================================================
          MAIN CONTENT
      ====================================================== */}

      <Box
        sx={{
          px: {
            xs: 1.5,
            sm: 2,
            md: 3,
          },
        }}
      >
        <Box

          component="form"

          onSubmit={handleSubmit}

          sx={{

            minWidth: 0,

          }}

        >

          {/* ==================================================

              COMPANY PROFILE

          ================================================== */}



          <SettingsCard

            id="company-section-company"

            icon={<BusinessOutlined />}

            title="Company Profile"

            subtitle="Basic company information"

          >

            <Alert

              severity="info"

              sx={{

                mb: 2.5,

                borderRadius: "6px",

                backgroundColor: "#F5FAFF",

                border: "1px solid #D6EBFF",

                color: "#344054",



                "& .MuiAlert-icon": {

                  color: "#1976D2",

                },

              }}

            >

              This information will appear on invoices,

              quotations, receipts and other business

              documents.

            </Alert>



            <Box

              sx={{

                display: "grid",

                gridTemplateColumns: {

                  xs: "1fr",

                  md: "190px minmax(0, 1fr)",

                },

                gap: 3,

              }}

            >

              {/* LOGO */}



              <Box>

                <Typography

                  sx={{

                    fontSize: 13,

                    fontWeight: 600,

                    color: "#344054",

                    mb: 1,

                  }}

                >

                  Company Logo

                </Typography>



                <Box

                  sx={{

                    height: 150,

                    border: "1px dashed #CBD5E1",

                    borderRadius: "6px",

                    backgroundColor: "#FAFBFC",

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",

                    flexDirection: "column",

                    position: "relative",

                    px: 2,

                  }}

                >

                  {logoPreview ? (

                    <>

                      <Box

                        component="img"

                        src={logoPreview}

                        alt="Company Logo"

                        sx={{

                          maxWidth: "90%",

                          maxHeight: 65,

                          objectFit: "contain",

                          mb: 2,

                        }}

                      />



                      <IconButton

                        size="small"

                        onClick={handleRemoveLogo}

                        sx={{

                          position: "absolute",

                          top: 6,

                          right: 6,

                          width: 26,

                          height: 26,

                          borderRadius: "6px",

                          backgroundColor: "#FFFFFF",

                          border:

                            "1px solid #E4E7EC",



                          "&:hover": {

                            backgroundColor:

                              "#FEF3F2",

                          },

                        }}

                      >

                        <Clear fontSize="small" />

                      </IconButton>

                    </>

                  ) : (

                    <Box

                      sx={{

                        width: 44,

                        height: 44,

                        borderRadius: "6px",

                        backgroundColor: "#E6F7F7",

                        color: "#008B8B",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        mb: 1,

                      }}

                    >

                      <BusinessOutlined />

                    </Box>

                  )}



                  <Button

                    component="label"

                    variant="outlined"

                    size="small"

                    startIcon={

                      <CloudUploadOutlined />

                    }

                    sx={{

                      height: 34,

                      borderRadius: "6px",

                      textTransform: "none",

                      borderColor: "#008B8B",

                      color: "#008B8B",

                      fontWeight: 600,



                      "&:hover": {

                        borderColor: "#006F6F",

                        backgroundColor: "#F0FAFA",

                      },

                    }}

                  >

                    {logoPreview

                      ? "Change Logo"

                      : "Upload Logo"}



                    <input

                      hidden

                      type="file"

                      accept="image/png,image/jpeg,image/webp"

                      onChange={

                        handleLogoUpload

                      }

                    />

                  </Button>

                </Box>



                <Typography

                  sx={{

                    mt: 0.8,

                    fontSize: 10.5,

                    color: "#98A2B3",

                  }}

                >

                  PNG, JPG or WEBP · Max 2 MB

                </Typography>

              </Box>



              {/* COMPANY FIELDS */}



              <Box

                sx={{

                  display: "grid",

                  gridTemplateColumns: {

                    xs: "1fr",

                    sm: "repeat(2, minmax(0, 1fr))",

                  },

                  gap: 2,

                  alignContent: "start",

                }}

              >

                <Field

                  required

                  label="Company Name"

                  name="companyName"

                  value={formData.companyName}

                  onChange={handleChange}

                />



                <Field

                  label="Legal Name"

                  name="legalName"

                  value={formData.legalName}

                  onChange={handleChange}

                />



                <Field

                  select

                  label="Company Type"

                  name="companyType"

                  value={formData.companyType}

                  onChange={handleChange}

                >

                  <MenuItem value="Proprietorship">

                    Proprietorship

                  </MenuItem>



                  <MenuItem value="Partnership">

                    Partnership

                  </MenuItem>



                  <MenuItem value="LLP">

                    LLP

                  </MenuItem>



                  <MenuItem value="Private Limited">

                    Private Limited

                  </MenuItem>



                  <MenuItem value="Public Limited">

                    Public Limited

                  </MenuItem>

                </Field>



                <Field

                  label="Website"

                  name="website"

                  value={formData.website}

                  onChange={handleChange}

                  startIcon={

                    <LanguageOutlined fontSize="small" />

                  }

                />



                <Field

                  type="email"

                  label="Email Address"

                  name="email"

                  value={formData.email}

                  onChange={handleChange}

                  startIcon={

                    <EmailOutlined fontSize="small" />

                  }

                />



                <Field

                  label="Phone"

                  name="phone"

                  value={formData.phone}

                  onChange={handleChange}

                  startIcon={

                    <PhoneOutlined fontSize="small" />

                  }

                />



                <Field

                  label="Mobile"

                  name="mobile"

                  value={formData.mobile}

                  onChange={handleChange}

                />

              </Box>

            </Box>

          </SettingsCard>



          {/* ==================================================

              BUSINESS ADDRESS

          ================================================== */}



          <SettingsCard

            id="company-section-address"

            icon={<LocationOnOutlined />}

            title="Business Address"

            subtitle="Registered and communication address"

          >

            <Box

              sx={{

                display: "grid",

                gridTemplateColumns: {

                  xs: "1fr",

                  md: "repeat(2, minmax(0, 1fr))",

                },

                gap: 2,

              }}

            >

              <Box

                sx={{

                  gridColumn: {

                    xs: "auto",

                    md: "span 2",

                  },

                }}

              >

                <Field

                  multiline

                  rows={2}

                  label="Address Line 1"

                  name="address1"

                  value={formData.address1}

                  onChange={handleChange}

                />

              </Box>



              <Box

                sx={{

                  gridColumn: {

                    xs: "auto",

                    md: "span 2",

                  },

                }}

              >

                <Field

                  label="Address Line 2"

                  name="address2"

                  value={formData.address2}

                  onChange={handleChange}

                />

              </Box>



              <Field

                label="City"

                name="city"

                value={formData.city}

                onChange={handleChange}

              />



              <Field

                select

                label="State"

                name="state"

                value={formData.state}

                onChange={handleChange}

              >

                <MenuItem value="Tamil Nadu">

                  Tamil Nadu

                </MenuItem>



                <MenuItem value="Kerala">

                  Kerala

                </MenuItem>



                <MenuItem value="Karnataka">

                  Karnataka

                </MenuItem>



                <MenuItem value="Andhra Pradesh">

                  Andhra Pradesh

                </MenuItem>



                <MenuItem value="Telangana">

                  Telangana

                </MenuItem>



                <MenuItem value="Maharashtra">

                  Maharashtra

                </MenuItem>



                <MenuItem value="Other">

                  Other

                </MenuItem>

              </Field>



              <Field

                label="Pincode"

                name="pincode"

                value={formData.pincode}

                onChange={handleChange}

              />



              <Field

                label="Country"

                name="country"

                value={formData.country}

                onChange={handleChange}

              />

            </Box>

          </SettingsCard>



          {/* ==================================================

              TAX

          ================================================== */}



          <SettingsCard

            id="company-section-tax"

            icon={<ReceiptLongOutlined />}

            title="Tax & Registration"

            subtitle="GST and statutory registration details"

          >

            <Box

              sx={{

                display: "grid",

                gridTemplateColumns: {

                  xs: "1fr",

                  sm: "repeat(2, minmax(0, 1fr))",

                  md: "repeat(3, minmax(0, 1fr))",

                },

                gap: 2,

              }}

            >

              <Field

                label="GSTIN"

                name="gstin"

                value={formData.gstin}

                onChange={handleChange}

                placeholder="22AAAAA0000A1Z5"

              />



              <Field

                label="PAN"

                name="pan"

                value={formData.pan}

                onChange={handleChange}

                placeholder="AAAAA0000A"

              />



              <Field

                label="CIN"

                name="cin"

                value={formData.cin}

                onChange={handleChange}

              />



              <Field

                label="TAN"

                name="tan"

                value={formData.tan}

                onChange={handleChange}

              />



              <Field

                label="MSME / UDYAM Number"

                name="msme"

                value={formData.msme}

                onChange={handleChange}

              />

            </Box>

          </SettingsCard>



          {/* ==================================================

              BANK

          ================================================== */}



          <SettingsCard

            id="company-section-bank"

            icon={<AccountBalanceOutlined />}

            title="Bank Details"

            subtitle="Bank account information displayed on documents"

          >

            <Box

              sx={{

                display: "grid",

                gridTemplateColumns: {

                  xs: "1fr",

                  sm: "repeat(2, minmax(0, 1fr))",

                  md: "repeat(3, minmax(0, 1fr))",

                },

                gap: 2,

              }}

            >

              <Field

                label="Bank Name"

                name="bankName"

                value={formData.bankName}

                onChange={handleChange}

              />



              <Field

                label="Account Holder Name"

                name="accountHolder"

                value={formData.accountHolder}

                onChange={handleChange}

              />



              <Field

                label="Account Number"

                name="accountNumber"

                value={formData.accountNumber}

                onChange={handleChange}

              />



              <Field

                label="IFSC Code"

                name="ifsc"

                value={formData.ifsc}

                onChange={handleChange}

              />



              <Field

                label="Branch"

                name="branch"

                value={formData.branch}

                onChange={handleChange}

              />

            </Box>

          </SettingsCard>



          {/* ==================================================

              DOCUMENT NUMBERING

          ================================================== */}



          <SettingsCard

            id="company-section-documents"

            icon={<ReceiptLongOutlined />}

            title="Document Numbering"

            subtitle="Configure prefixes used for business documents"

          >

            <Box

              sx={{

                p: 1.5,

                mb: 2,

                backgroundColor: "#F8FAFC",

                border: "1px solid #EAECF0",

                borderRadius: "6px",

              }}

            >

              <Typography

                sx={{

                  fontSize: 12.5,

                  color: "#667085",

                }}

              >

                These prefixes will be used when

                automatically generating document numbers.

              </Typography>

            </Box>



            <Box

              sx={{

                display: "grid",

                gridTemplateColumns: {

                  xs: "1fr",

                  sm: "repeat(2, minmax(0, 1fr))",

                  md: "repeat(4, minmax(0, 1fr))",

                },

                gap: 2,

              }}

            >

              <Field

                label="Invoice Prefix"

                name="invoicePrefix"

                value={formData.invoicePrefix}

                onChange={handleChange}

              />



              <Field

                label="Quotation Prefix"

                name="quotationPrefix"

                value={formData.quotationPrefix}

                onChange={handleChange}

              />



              <Field

                label="Purchase Prefix"

                name="purchasePrefix"

                value={formData.purchasePrefix}

                onChange={handleChange}

              />



              <Field

                label="Receipt Prefix"

                name="receiptPrefix"

                value={formData.receiptPrefix}

                onChange={handleChange}

              />

            </Box>

          </SettingsCard>



          {/* ==================================================

              TERMS

          ================================================== */}



          <SettingsCard

            id="company-section-terms"

            icon={<ReceiptLongOutlined />}

            title="Invoice Terms & Notes"

            subtitle="Default information displayed on invoices"

          >

            <Box

              sx={{

                display: "grid",

                gridTemplateColumns: "1fr",

                gap: 2,

              }}

            >

              <Field

                multiline

                rows={4}

                label="Terms & Conditions"

                name="invoiceTerms"

                value={formData.invoiceTerms}

                onChange={handleChange}

              />



              <Field

                multiline

                rows={3}

                label="Invoice Notes"

                name="invoiceNotes"

                value={formData.invoiceNotes}

                onChange={handleChange}

              />

            </Box>

          </SettingsCard>



          {/* ==================================================

              SAVE BAR

          ================================================== */}



          <Paper

            elevation={0}

            sx={{

              position: "sticky",

              bottom: 10,

              zIndex: 20,

              border: "1px solid #D0D5DD",

              borderRadius: "6px",

              backgroundColor:

                "rgba(255,255,255,0.97)",

              backdropFilter: "blur(8px)",

              p: 1.5,

              boxShadow:

                "0 4px 15px rgba(16,24,40,0.08)",

            }}

          >

            <Box

              sx={{

                display: "flex",

                justifyContent: "space-between",

                alignItems: "center",

                gap: 2,



                flexDirection: {

                  xs: "column",

                  sm: "row",

                },

              }}

            >

              <Typography

                sx={{

                  fontSize: 12,

                  color: "#667085",

                }}

              >

                Your company information will be used

                throughout the CRM.

              </Typography>



              <Box

                sx={{

                  display: "flex",

                  gap: 1,

                }}

              >

                <Button

                  variant="outlined"

                  onClick={handleReset}

                  sx={{

                    height: 38,

                    px: 2,

                    borderRadius: "6px",

                    textTransform: "none",

                    borderColor: "#D0D5DD",

                    color: "#475467",

                  }}

                >

                  Cancel

                </Button>



                <Button

                  type="submit"

                  variant="contained"

                  startIcon={<SaveOutlined />}

                  sx={{

                    height: 38,

                    px: 2.5,

                    borderRadius: "6px",

                    textTransform: "none",

                    fontWeight: 600,

                    backgroundColor: "#008B8B",

                    boxShadow: "none",



                    "&:hover": {

                      backgroundColor: "#006F6F",

                      boxShadow: "none",

                    },

                  }}

                >

                  Save Changes

                </Button>

              </Box>

            </Box>

          </Paper>

        </Box>

      </Box>

    </Box>

  );

};



/* ================================================================

   SETTINGS CARD

\================================================================ */



const SettingsCard = ({

  id,

  icon,

  title,

  subtitle,

  children,

}) => {

  return (

    <Paper

      id={id}

      elevation={0}

      sx={{

        mb: 2,

        border: "1px solid #E4E7EC",

        borderRadius: "6px",

        backgroundColor: "#FFFFFF",

        overflow: "hidden",

        scrollMarginTop: "20px",

      }}

    >

      {/* HEADER */}



      <Box

        sx={{

          px: {

            xs: 1.8,

            md: 2.5,

          },

          py: 1.7,

          display: "flex",

          alignItems: "center",

          gap: 1.3,

          backgroundColor: "#FCFCFD",

          borderBottom: "1px solid #EAECF0",

        }}

      >

        <Box

          sx={{

            width: 36,

            height: 36,

            flexShrink: 0,

            borderRadius: "6px",

            display: "flex",

            alignItems: "center",

            justifyContent: "center",

            backgroundColor: "#E6F7F7",

            color: "#008B8B",

          }}

        >

          {React.cloneElement(icon, {

            fontSize: "small",

          })}

        </Box>



        <Box>

          <Typography

            sx={{

              fontSize: 14.5,

              fontWeight: 700,

              color: "#1D2939",

            }}

          >

            {title}

          </Typography>



          <Typography

            sx={{

              mt: 0.25,

              fontSize: 11.5,

              color: "#98A2B3",

            }}

          >

            {subtitle}

          </Typography>

        </Box>

      </Box>



      {/* CONTENT */}



      <Box

        sx={{

          p: {

            xs: 1.8,

            md: 2.5,

          },

        }}

      >

        {children}

      </Box>

    </Paper>

  );

};



/* ================================================================

   FIELD

\================================================================ */



const Field = ({

  label,

  name,

  value,

  onChange,

  required = false,

  select = false,

  children,

  multiline = false,

  rows,

  type = "text",

  placeholder,

  startIcon,

}) => {

  return (

    <TextField

      fullWidth

      size="small"

      required={required}

      select={select}

      label={label}

      name={name}

      value={value}

      onChange={onChange}

      multiline={multiline}

      rows={rows}

      type={type}

      placeholder={placeholder}

      InputProps={

        startIcon

          ? {

              startAdornment: (

                <Box

                  sx={{

                    display: "flex",

                    alignItems: "center",

                    color: "#98A2B3",

                    mr: 0.7,

                  }}

                >

                  {startIcon}

                </Box>

              ),

            }

          : undefined

      }

      sx={{

        "& .MuiOutlinedInput-root": {

          borderRadius: "6px",

          backgroundColor: "#FFFFFF",

          fontSize: 13.5,

          minHeight: 40,



          "& fieldset": {

            borderColor: "#D0D5DD",

            borderWidth: "1px",

          },



          "&:hover fieldset": {

            borderColor: "#98A2B3",

          },



          "&.Mui-focused fieldset": {

            borderColor: "#008B8B",

            borderWidth: "1px",

          },

        },



        "& .MuiInputLabel-root": {

          fontSize: 12.5,

          color: "#667085",

        },



        "& .MuiInputLabel-root.Mui-focused": {

          color: "#008B8B",

        },



        "& .MuiInputBase-input": {

          boxSizing: "border-box",

          padding: "9px 11px",

        },



        "& .MuiSelect-select": {

          minHeight: "40px !important",

          boxSizing: "border-box",

          display: "flex",

          alignItems: "center",

          padding:

            "9px 32px 9px 11px !important",

        },



        "& textarea.MuiInputBase-input": {

          padding: "10px 11px",

        },

      }}

    >

      {children}

    </TextField>

  );

};



export default CompanySetup;